import React from 'react';

import Page from 'marketing-website/components/modules/Page';
import assets from 'marketing-website/configs/pages/consultancies/assets';
import logos from 'marketing-website/configs/pages/consultancies/logos';
import ImageBlock from 'marketing-website/components/modules/ImageBlock';
import CTA from 'marketing-website/components/modules/Cta/CtaDemo';
import Logos from 'marketing-website/components/modules/Logos';
import IndustryHeader from 'marketing-website/components/modules/IndustryHeader';
import { requestDemoConsultancyId } from 'marketing-website/configs/hubspot';
import metaData from 'marketing-website/data/metadata.js';

const facebookMeta = [
  {
    name: 'og:title',
    content: 'Marvel for Consulting - Drive innovation through design',
  },
  {
    name: 'og:site_name',
    content: 'Marvel for Consulting',
  },
  {
    name: 'og:type',
    content: 'website',
  },
  {
    name: 'og:url',
    content: 'https://marvelapp.com/financial-services',
  },
  {
    name: 'og:description',
    content:
      "Explore how Marvel's collaborative design platform can help introduce innovation management and design thinking for digital transformation.",
  },
  {
    name: 'og:image',
    content: `https://marvelapp.com${assets.sharePreview.src}`,
  },
  {
    name: 'og:site_name',
    content: 'Marvel for Consulting',
  },
];

const twitterMeta = [
  {
    name: 'twitter:site',
    content: 'https://marvelapp.com/financial-services',
  },
  {
    name: 'twitter:creator',
    content: '@marvelapp',
  },
  {
    name: 'twitter:title',
    content: 'Marvel for Consulting - Drive innovation through design',
  },
  {
    name: 'twitter:image',
    content: `https://marvelapp.com${assets.sharePreview.src}`,
  },
];

const meta = {
  title: metaData.consultancies.title,
  meta: [
    {
      name: 'description',
      content: metaData.consultancies.description,
    },
    ...twitterMeta,
    ...facebookMeta,
  ],
  header: { isLight: false },
  footer: false,
};

export default function Consultancies() {
  const ctaLink = `/enterprise/request-demo?hformid=${requestDemoConsultancyId}`;
  return (
    <Page {...meta}>
      <IndustryHeader
        label="Marvel for Consultancies"
        imageAsset={assets.hero}
        title="Drive digital transformation through innovative design"
        paragraph={
          <span>
            Marvel helps consultancies around the world deliver exceptional
            client and customer experiences through a suite of tools that power
            collaborative design, prototyping and testing at scale. <br />
            <br />
            Set your clients up for success through delivering innovative,
            user-centric design solutions with Marvel.
          </span>
        }
        ctaLink={ctaLink}
      />
      <Logos
        title={
          <span>
            Join these leading consulting companies who use{' '}
            <span style={{ fontWeight: 'bold' }}>Marvel Enterprise</span> to
            scale design
          </span>
        }
        logos={logos}
      />

      <ImageBlock
        paragraphSize="m"
        title="Democratise design by giving every team access to the right tools"
        copy={
          <span>
            From designers to researchers and analysts, Marvel consolidates and
            simplifies dozens of professional, creative workflow tools -
            enabling every department to wireframe, design and prototype. <br />
            <br />
            We strive to lower the entry barrier for design and creative
            tooling. That's why it takes less than 30 minutes to onboard and
            complete your first project with Marvel. With no learning curve, our
            platform empowers every team to drive a design-led culture.
          </span>
        }
        headingMaxWidth={390}
        paragraphMaxWidth={480}
        imageAsset={assets.democratise}
        ctaLink={ctaLink}
      />

      <ImageBlock
        paragraphSize="m"
        title="Get buy-in early on with feedback loops reduced to minutes, not days"
        copy={
          <span>
            Increase transparency between teams, managers and stakeholders with
            Marvel's open collaboration tools, including comments, annotations
            and visibility dashboards. You'll see feedback become more
            contextual and meaningful, instantly.
            <br />
            <br />
            With Marvel, you'll experience a streamlined sign-off workflow,
            moving effortlessly from idea through to delivery.
          </span>
        }
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.feedback}
        isRightAligned
        ctaLink={ctaLink}
      />

      <ImageBlock
        paragraphSize="m"
        title="Co-creation tools that turn clients into collaborators"
        copy={
          <span>
            We believe that the strongest relationships form when clients are
            made to feel part of the process. Marvel helps you keep clients and
            stakeholders in the loop every step of the way, whether you're
            brainstorming or reviewing final designs.
            <br />
            <br />
            Our apps help you turn paper sketches into interactive prototypes,
            great for early stage concepts during client sessions. Further
            along, prototypes will update design changes in real time from
            Sketch. Need to control access to prototypes? We have a range of
            user roles including an external reviewer setting.
          </span>
        }
        headingMaxWidth={458}
        paragraphMaxWidth={458}
        imageAsset={assets.collaborate}
        ctaLink={ctaLink}
      />

      <ImageBlock
        paragraphSize="m"
        title="Validate ideas at speed with user testing"
        copy={
          <span>
            Reach your client's end-users and generate valuable data to help you
            and clients create innovative and user-centric design solutions.
            Marvel comes with User Testing built in, which means you can get
            rich video, audio and analytical feedback on your designs in just a
            few clicks.
            <br />
            <br />
            Test with your team, clients and end-users by simply sending a link.
            No hardware or lab required!
          </span>
        }
        headingMaxWidth={458}
        paragraphMaxWidth={458}
        imageAsset={assets.validate}
        isRightAligned
        ctaLink={ctaLink}
      />

      <ImageBlock
        paragraphSize="m"
        title="The tools you need to scale Design Thinking"
        copy="Our platform and content help power workshops around problem-solving approaches including design sprints, code-free prototyping, helping up-skill non-designers with modern idea-to-launch methodologies and frameworks."
        headingMaxWidth={458}
        paragraphMaxWidth={458}
        imageAsset={assets.scale}
        ctaLink={ctaLink}
      />

      <div className="bg-snow">
        <CTA
          heading="Challenge the industry norm and become a CX centric design leader with Marvel Enterprise."
          ctaLink={ctaLink}
        />
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/consultancies/index.js